import PortalVue from 'portal-vue'
import VueResizeObserver from 'vue-resize-observer'
import Toasted from '@hoppscotch/vue-toasted'
import '@hoppscotch/vue-toasted/style.css'
import i18n from '@/plugins/i18n.js'

export default function ({ app, router }) {
  app.use(router)
  app.use(i18n)
  app.use(PortalVue)
  app.use(VueResizeObserver)
  app.use(Toasted, {
    router,
    position: 'top-center',
    containerClass: 'safe-area-top',
    fullWidth: true,
    fitToScreen: true
  })
}
